import { addMoney, zeroMoney } from "@KassaroAB/shared/utils/money";
import { Currency } from "@KassaroAB/shared/types/enums/currency";
import type { Money } from "@KassaroAB/shared/types/money";
import type { ResellerId } from "@KassaroAB/shared/types/ids";
import type { RestKickbackSourceReport } from "@KassaroAB/shared/types/invoices/kickback";

export const sumMoney = (amounts: Money[]) =>
  amounts.reduce(
    (total, amount) => addMoney(total, amount),
    zeroMoney(amounts[0]?.currency ?? Currency.SEK)
  );

export type ResellerKickbackTotal = {
  resellerId: ResellerId;
  resellerName: string;
  rowCount: number;
  profitShare: Money;
};

export const totalsByReseller = (
  reports: RestKickbackSourceReport[]
): ResellerKickbackTotal[] => {
  const totals = new Map<ResellerId, ResellerKickbackTotal>();
  for (const row of reports.flatMap((report) => report.rows)) {
    if (row.resellerId === null) {
      continue;
    }
    const existing = totals.get(row.resellerId);
    totals.set(row.resellerId, {
      resellerId: row.resellerId,
      resellerName: row.resellerName ?? row.resellerId,
      rowCount: (existing?.rowCount ?? 0) + 1,
      profitShare: existing
        ? addMoney(existing.profitShare, row.profitShare)
        : row.profitShare,
    });
  }
  return [...totals.values()].sort((left, right) =>
    left.resellerName.localeCompare(right.resellerName, "sv")
  );
};
